import { getOrderShowtimes } from './get-order-showtimes';
export const getOrderShowtimeById = (showtimeId) => {
    return getOrderShowtimes().find(showtime => showtime.showtimeId === showtimeId);
};
